import { useMutation } from '@tanstack/react-query'
import { discountCodeCheck } from '../../service/payment'

export const useDiscount = () => {
  return useMutation({
    mutationKey: ['discount'],
    mutationFn: discountCodeCheck,
  })
}
